import utils from "./terraUtils";

function convertToReadableDate(timestamp) {
  return new Date(timestamp).toDateString();
}

const mapMetrics = async (data) => {
  return Promise.all(
    data.metrics.map(async (metric) => {
      return {
        validator: await utils.mapValidator(metric.validator),
        timestamp: convertToReadableDate(metric.timestamp),
        apr: Number(metric.apr * 100).toPrecision(3) + " %",
      };
    })
  );
};

function mapTimestamp(timestamp) {
  return {
    timestamp: timestamp,
    readable: convertToReadableDate(timestamp),
  };
}

const converterUtil = { mapMetrics, mapTimestamp };
export default converterUtil;
